import React from "react";
import { createRoot } from "react-dom/client";
import { setupIonicReact } from "@ionic/react";
import { App } from "./App";
import { BootSplash } from "./components/BootSplash";
import { initialiseNative } from "./native";

import "@ionic/react/css/core.css";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";
import "@y3lo/ui/styles.css";
import "./theme.css";

// no `mode` override — Ionic auto-detects iOS HIG vs Android Material
setupIonicReact({
  rippleEffect: true,
  hardwareBackButton: true,
  swipeBackEnabled: true,
  animated: true
});

initialiseNative();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
    {/* ignition boot curtain — self-gating (native always, web app-users once
        per session), portals to body, unmounts itself when the app is in */}
    <BootSplash />
  </React.StrictMode>
);
